"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[97657],{

/***/ 628054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(431529);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(693701);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(622746);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SubTitle13 = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK)``;
const BasePage = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  z-index: 1;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const InteractPage = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(BasePage)(({ theme, active, disabled, color }) => `
border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
background-color: ${active ? (theme == null ? void 0 : theme.colors[color]) || color : theme == null ? void 0 : theme.colors.white};
border: ${active ? "none" : `1px solid ${theme == null ? void 0 : theme.colors.divider}`};
pointer-events: ${disabled ? "none" : "auto"};
${!active ? `
  cursor: pointer;
  &:hover {
    path[stroke],
    rect[stroke],
    line {
      stroke: ${theme == null ? void 0 : theme.colors.white};
    }
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${theme == null ? void 0 : theme.colors.white};
    }
    ${SubTitle13} {
      color: ${theme == null ? void 0 : theme.colors.white};
    }
    background-color: ${theme == null ? void 0 : theme.colors.background};
  }` : `
  ${SubTitle13} {
    color: ${theme == null ? void 0 : theme.colors.white};
  }
`}
`);
const PaginationWrap = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: inline-flex;
  > *:not(:first-child) {
    margin-left: ${({ theme }) => theme == null ? void 0 : theme.spacing.s8};
  }
`;
const StyledPagination = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F};
  width: 100%;
  text-align: ${(p) => p.align};
`;
const range = (from, to) => {
  return Array.from({ length: to - from + 1 }, (v, k) => k + from);
};
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const generatePageNumbers = (totalPages, currentPage, pageNeighbor) => {
  const totalNumbers = pageNeighbor * 2 + 3;
  const totalBlocks = totalNumbers + 2;
  if (totalPages > totalBlocks) {
    let pages = [];
    const curr = currentPage > totalPages ? totalPages : currentPage;
    const leftBound = curr - pageNeighbor;
    const rightBound = curr + pageNeighbor;
    const beforeLastPage = totalPages - 1;
    const startPage = leftBound > 2 ? leftBound : 2;
    const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
    pages = range(startPage, endPage);
    const pagesCount = pages.length;
    const singleSpillOffset = totalNumbers - pagesCount - 1;
    const leftSpill = startPage > 2;
    const rightSpill = endPage < beforeLastPage;
    const leftSpillPage = LEFT_PAGE;
    const rightSpillPage = RIGHT_PAGE;
    if (leftSpill && !rightSpill) {
      const extraPages = range(startPage - singleSpillOffset, startPage - 1);
      pages = [leftSpillPage, ...extraPages, ...pages];
    } else if (!leftSpill && rightSpill) {
      const extraPages = range(endPage + 1, endPage + singleSpillOffset);
      pages = [...pages, ...extraPages, rightSpillPage];
    } else if (leftSpill && rightSpill) {
      pages = [leftSpillPage, ...pages, rightSpillPage];
    }
    return [1, ...pages, totalPages];
  }
  return range(1, totalPages);
};
const Pagination = (_a) => {
  var _b = _a, {
    totalRecords,
    currentPage,
    pageLimit = 30,
    pageNeighbor = 2,
    onPageChange,
    align = "center",
    color = "primary500",
    itemRender
  } = _b, rest = __objRest(_b, [
    "totalRecords",
    "currentPage",
    "pageLimit",
    "pageNeighbor",
    "onPageChange",
    "align",
    "color",
    "itemRender"
  ]);
  var _a2;
  const totalPages = Math.ceil(totalRecords / pageLimit);
  const gotoPage = (page) => {
    onPageChange == null ? void 0 : onPageChange(page);
  };
  const onBackward = () => {
    gotoPage(currentPage - 1);
  };
  const onForward = () => {
    gotoPage(currentPage + 1);
  };
  const pages = generatePageNumbers(totalPages, currentPage, pageNeighbor);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPagination, __spreadValues({
    align
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationWrap, null, (itemRender == null ? void 0 : itemRender["pre"]) ? (_a2 = itemRender["pre"]) == null ? void 0 : _a2.call(itemRender, currentPage - 1, {
    color,
    disabled: currentPage === 1
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InteractPage, __spreadValues({
    color,
    disabled: currentPage === 1,
    onClick: onBackward
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "previousPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .BackOutlined */ .Y, {
    size: 16,
    color: "placeholder"
  })), pages.map((page, index) => {
    var _a3;
    if ([LEFT_PAGE, RIGHT_PAGE].includes(page.toString())) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BasePage, {
        key: index
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .DotOutlined */ .h, {
        size: 16,
        color: "border"
      }));
    }
    const isActive = page === currentPage;
    return (itemRender == null ? void 0 : itemRender["page"]) ? (_a3 = itemRender["page"]) == null ? void 0 : _a3.call(itemRender, page, {
      color,
      active: isActive
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InteractPage, __spreadValues({
      color,
      active: isActive,
      key: index,
      onClick: isActive ? void 0 : () => onPageChange == null ? void 0 : onPageChange(typeof page === "string" ? parseInt(page) : page)
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName: "paging",
      contentName: "gotoPage",
      target: `${page}`
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SubTitle13, {
      level: 4,
      color: isActive ? "white" : "textPrimary"
    }, page));
  }), (itemRender == null ? void 0 : itemRender["next"]) ? itemRender["next"](currentPage + 1, {
    color,
    disabled: currentPage === 1
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InteractPage, __spreadValues({
    color,
    disabled: currentPage === totalPages,
    onClick: onForward
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "nextPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .ForwardOutlined */ .d, {
    size: 16,
    color: "placeholder"
  }))));
};




/***/ }),

/***/ 693701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DotOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DotOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M3 15C4.65685 15 6 13.6569 6 12C6 10.3431 4.65685 9 3 9C1.34315 9 0 10.3431 0 12C0 13.6569 1.34315 15 3 15Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 622746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ForwardOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ForwardOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.5 19L15.5 12L8.5 5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 159586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ JustForYou; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(628054);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(806748);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ProductGrid_ProductGrid_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(480219);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(842918);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ForwardOutlined = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(2067), __webpack_require__.e(75403)]).then(__webpack_require__.bind(__webpack_require__, 102067)).then((mod) => mod.ForwardOutlined));
const JustForYou = (_a) => {
  var _b = _a, {
    header,
    products,
    productsPerRow,
    pagination,
    isMobile,
    isLoading
  } = _b, rest = __objRest(_b, [
    "header",
    "products",
    "productsPerRow",
    "pagination",
    "isMobile",
    "isLoading"
  ]);
  if (!products || !products.length)
    return null;
  const hasMore = ((pagination == null ? void 0 : pagination.totalRecords) || 0) > ((pagination == null ? void 0 : pagination.currentPage) || 1) * ((pagination == null ? void 0 : pagination.pageLimit) || 0);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BlockHeader */ .t, __spreadProps(__spreadValues({}, header), {
    title: header.title || (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("S\u1EA3n ph\u1EA9m d\xE0nh cho b\u1EA1n")
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ProductGrid_ProductGrid_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductGrid */ .e, {
    products,
    productsPerRow: productsPerRow || (isMobile ? 2 : 5),
    regionName: "forYouListProduct"
  })), !isMobile && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b, {
    marginTop: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .t, __spreadProps(__spreadValues({}, pagination), {
    totalRecords: pagination == null ? void 0 : pagination.totalRecords,
    currentPage: pagination == null ? void 0 : pagination.currentPage
  }))), isMobile && hasMore && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
    justify: "center",
    marginBottom: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ShowMoreButton, {
    variant: "link",
    suffix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ForwardOutlined, null),
    disabled: isLoading,
    onClick: (e) => {
      var _a2;
      e == null ? void 0 : e.preventDefault();
      (_a2 = pagination == null ? void 0 : pagination.onPageChange) == null ? void 0 : _a2.call(pagination, ((pagination == null ? void 0 : pagination.currentPage) || 1) + 1);
    }
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Xem th\xEAm s\u1EA3n ph\u1EA9m"))));
};
JustForYou.displayName = "JustForYou";
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div`
  background: white;
  border-radius: 0.5rem;
`;
const ShowMoreButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z)`
  min-width: 250px;
  padding: 0.625rem 0.5rem;
  background-color: #fff;
  text-align: center;

  :active,
  :hover,
  :focus {
    text-decoration: none;
  }

  :active {
    color: ${({ theme }) => theme.colors.link500};
  }

  > div {
    display: unset;
  }
`;




/***/ }),

/***/ 910769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DiscoveryRecommendedProducts": function() { return /* binding */ DiscoveryRecommendedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(159586);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88837);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(185081);
/* harmony import */ var _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(243846);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const HEADER_HEIGHT = 56;
const DiscoveryRecommendedProducts = (param)=>{
    let { paramsObject , title , actionLink , itemsPerPage , ssrProducts =[]  } = param;
    const { location , isMobile  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { 0: pageNumber , 1: setPageNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const { 0: productList , 1: setProductList  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: totalItems , 1: setTotalItems  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const pageSize = itemsPerPage || constants_index__WEBPACK_IMPORTED_MODULE_3__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl;
    const { isLoading , transformProduct  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useSearch */ .Rx)(_objectSpreadProps(_objectSpread({}, paramsObject), {
        page: pageNumber,
        location,
        pageSize: constants_index__WEBPACK_IMPORTED_MODULE_3__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl,
        sorting: {
            sort: _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_5__/* .SortEnum.SORT_BY_TOP_SALE_QUANTITY_30_DAYS */ .J.SORT_BY_TOP_SALE_QUANTITY_30_DAYS
        }
    }), {
        products: ssrProducts
    }, {
        /**
       * Mobile: append new products to the list
       * Desktop: replace the current products list
       * */ onSuccess: (response)=>{
            const { pagination , products  } = response;
            setTotalItems(pagination === null || pagination === void 0 ? void 0 : pagination.totalItems);
            if (isMobile) {
                setProductList([
                    ...productList,
                    ...products || []
                ]);
            } else {
                setProductList(products || []);
            }
        },
        onError: ()=>{
            if (!isMobile) {
                setProductList([]);
            }
        }
    });
    const top = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const handlePageChanged = (page)=>{
        if (!isMobile && top && top.current) {
            const element = top.current;
            window.scrollTo({
                left: 0,
                top: getElementOffset(element).top - HEADER_HEIGHT - 30
            });
        }
        setPageNumber(page);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: top,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .JustForYou */ .L, {
            header: {
                title: title || "",
                link: totalItems > pageSize && actionLink || undefined,
                style: {
                    paddingLeft: "16px"
                }
            },
            products: productList === null || productList === void 0 ? void 0 : productList.map(transformProduct),
            productsPerRow: isMobile ? 2 : 5,
            pagination: {
                totalRecords: totalItems,
                currentPage: pageNumber,
                pageLimit: pageSize,
                pageNeighbor: 2,
                onPageChange: handlePageChanged,
                color: "primary500"
            },
            isMobile: isMobile,
            isLoading: isLoading
        })
    });
};
//get element offset relative to the document
const getElementOffset = (elem)=>{
    const box = elem.getBoundingClientRect();
    const body = document.body;
    const docEl = document.documentElement;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;
    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;
    return {
        top,
        left
    };
};


/***/ })

}]);